module.exports = __webpack_public_path__ + "img/first-block-title.20c78116.png";